<div class="pl-3 notes-container">
  <div *ngIf="loadingSubject$ | async" class="spinner-container">
    <p-progressSpinner></p-progressSpinner>
  </div>
  <span *ngIf="!(loadingSubject$ | async)" class="font-weight-normal count-container">{{ notes?.length || 0 }}</span>
  <fa-icon [icon]="['fas', 'sticky-note']" [size]="iconSize" class="ml-1 icon-detail" pTooltip="Notes" (click)="viewNotesClicked()">
  </fa-icon>
</div>
